import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { Home } from "lucide-react";

export default function AppLayout() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="min-h-screen bg-background">
      {!isHome && (
        <div className="w-full px-6 lg:px-12 pt-6">
          <Link
            to="/"
            data-testid="back-home-link"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:opacity-75 transition-opacity"
          >
            <Home className="w-4 h-4" />
            Home
          </Link>
        </div>
      )}
      <main className="w-full px-6 lg:px-12 py-6">
        <Outlet />
      </main>
    </div>
  );
}
